import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllClaimTypeFieldService = ({
  page = "1",
  per_page = "50",
  enableQuery = true,
  filters = {},
  cacheKeys = [],
}: ICommonServiceProps) => {
  const [searchTemplate, setSearchTemplate] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchTemplate);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const claimTypeId = +urlQueries["claim-type-id"] || "";
  const allClaimTypeFieldService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIM_TYPE_FIELD,
      page,
      per_page,
      debouncedQuery,
      claimTypeId,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CLAIM_TYPE_FIELDS,
        searchParams: {
          page,
          per_page,
          ...filters,
          "filter[claim_type_id]": claimTypeId,
          include: "claimType,claimField.inputType",
        },
      }),
    enabled: enableQuery,
  });

  return {
    service: { allClaimTypeFieldService },
    state: { searchTemplate, setSearchTemplate },
  };
};
